import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import SubMenu from "@/views/SubMenu";
import Menu from "@/views/Menu";
import menun1 from "@/views/menun1";
import DigitalMenu from "@/views/DigitalMenu";
import Shop from "@/views/Shop";
import ChooseDigitalMenu from "@/views/ChooseDigitalMenu";
const routes = [
  {
    path: '/shop/:slug/ChooseDigitalMenu',
    name: 'ChooseDigitalMenu',
    component: ChooseDigitalMenu, 
  },
  {
    path: '/shop/:slug/digitalmenu/:id/:lanid',
    name: 'DigitalMenu',
    component: DigitalMenu,
  },
   {
    path: '/home',
    name: 'Home',
    component: Home,
   },    
   {
      path: '/shop/:slug',
      name: 'Shop',
      component: Shop,
    },
    {
      path: '/shop/:slug/menu/:id',
      name: 'Menu',
      component: Menu,
      children: [
        {
            path: ':idd',
            name: 'SubMenu',
            component: SubMenu
        },
    ],

    },
    {
      path: '/shop/:slug/menun1/:id',
      name: 'menun1',
      component: menun1
    },
    {
     path: '/shop/:slug/about',
     name: 'About',
     // route level code-splitting
     // this generates a separate chunk (about.[hash].js) for this route
     // which is lazy-loaded when the route is visited.
     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
      path: '/shop/:slug/menu',
      name: 'ChooseMenu',
      component: () => import(/* webpackChunkName: "about" */ '../views/ChooseMenu.vue')
     }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
